import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule, ROUTES } from '@angular/router';
import { CustomRoute } from './model/router-state.model';
import { ElioElioTypedRouterLinkedDirectiveModule } from './typed-routerLink.directive';

@NgModule({
  imports: [RouterModule, ElioElioTypedRouterLinkedDirectiveModule],
  exports: [RouterModule, ElioElioTypedRouterLinkedDirectiveModule],
})
export class ElioTypedRouterModule {
  static forChild(routes: CustomRoute[]): ModuleWithProviders<ElioTypedRouterModule> {
    return {
      ngModule: ElioTypedRouterModule,
      providers: [{ provide: ROUTES, multi: true, useValue: routes }],
    };
  }
}
